import { Component, OnInit, ViewChild } from '@angular/core';
import { SysUsersService } from '../services/sys-users.service';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import Swal, { SweetAlertIcon } from 'sweetalert2';
const Lockr = require("lockr");
@Component({
  selector: 'ngx-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  @ViewChild(SignaturePad, { static: true }) signaturePad: SignaturePad;
  signaturePadOptions: Object;
  user: any;
  accountId: any;
  isSuperAdmin: any;
  showEditSignature: boolean = false;
  loading: boolean = false;

  constructor(
    private userService: SysUsersService,
  ) { }

  async ngOnInit() {
    this.loading = true;
    this.signaturePadOptions = {
      maxWidth: 1,
      'minWidth': 0.8,
      'backgroundColor': 'RGBA(245, 247, 249, 1.00)',
      'canvasWidth': 550,
    };

    const user = Lockr.get('user');
    this.accountId = user.account ? user.account : user.user_id;
    const [error, { data: userData }] = await this.userService.getProfile(this.accountId, !user.account);
    if (error) return error;
    this.user = userData;

    this.loading = false;
  }

  clearSignature() {
    this.signaturePad.clear();
  }

  async updateSignature() {
    this.loading = true;
    const signature = this.signaturePad.toDataURL();

    const [error] = await this.userService.uploadSignature(this.accountId, signature, this.isSuperAdmin);
    this.loading = false;
    if (error) { return this.alert('Oops, algo pasó, intenta más tarde', 'error'); }

    this.user.signature = signature;
    this.showEditSignature = false;
    this.alert('Firma actualizada con éxito');
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
